import { has } from 'lodash'
import { BaseOutput, isBaseOutput } from './base-output.model'

export interface ResendSmsOutput extends BaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  DateTimeNextRequestIsAvailable: string
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isResendSmsOutput = (obj: any): obj is ResendSmsOutput => {
  const dateTimeNextRequestIsAvailable = 'DateTimeNextRequestIsAvailable'

  return isBaseOutput(obj) && has(obj, dateTimeNextRequestIsAvailable)
}
